import { useState } from "react";
import toast from "react-hot-toast";
import { AnalyzeReviewResponse, Review } from "../types";
import { API_CONFIG, getApiUrl } from "../config/api";

export const useReviewAnalysis = () => {
  const [analyzingReviews, setAnalyzingReviews] = useState<{
    [key: string]: boolean;
  }>({});

  const handleAnalyzeReview = async (
    reviewId: string,
    setReviews: React.Dispatch<React.SetStateAction<Review[]>>,
    platform?: "ozon" | "wildberries" | "yandex"
  ): Promise<boolean> => {
    setAnalyzingReviews((prev) => ({ ...prev, [reviewId]: true }));
    try {
      const token = localStorage.getItem("token");
      // Платформу теперь получаем напрямую из аргумента
      if (!platform) throw new Error("Не удалось определить платформу отзыва");

      const endpoint = getApiUrl(
        API_CONFIG.ENDPOINTS.EXTERNAL_REVIEW_AI_ANALYZE
      );
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ platform, externalReviewId: reviewId }),
      });

      if (response.ok) {
        const updatedReview: AnalyzeReviewResponse & {
          isAnalyzed: boolean;
          isResponded: boolean;
          isFallback: boolean;
        } = await response.json();
        setReviews((prev: Review[]) =>
          prev.map((review) => {
            if (review.id === reviewId) {
              // Объединяем только поля анализа, сохраняя остальные поля оригинального отзыва
              return {
                ...review,
                // Обновляем только поля анализа
                sentiment: updatedReview.sentiment as any,
                sentimentAnalysis: updatedReview.sentimentAnalysis,
                problems: updatedReview.problems,
                recommendations: updatedReview.recommendations,
                isAnalyzed: updatedReview.isAnalyzed,
                isResponded: updatedReview.isResponded,
                isFallback: updatedReview.isFallback,
              };
            }
            return review;
          })
        );
        toast.success("Анализ отзыва завершен!");
        return true;
      } else {
        // Не показываем глобальный тост, UI карточки сам отобразит плашку рядом с кнопкой
        console.error("Ошибка при анализе отзыва:", response.status);
        return false;
      }
    } catch (error) {
      // Не показываем глобальный тост, UI карточки сам отобразит плашку рядом с кнопкой
      console.error("Ошибка при анализе отзыва:", error);
      return false;
    } finally {
      setAnalyzingReviews((prev) => ({ ...prev, [reviewId]: false }));
    }
  };

  return {
    analyzingReviews,
    handleAnalyzeReview,
  };
};
